module.exports = __webpack_public_path__ + "static/img/y20.60f1c99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y20.jpg
// module id = 45Oa
// module chunks = 1